import { makeStyles } from '@material-ui/core';
import { Navigate, useRoutes, useSearchParams } from 'react-router-dom';
import { AssetDetails } from './asset/details/AssetDetails';
import { InspectionCreationWizard } from './asset/editor/InspectionCreationWizard';
import { AssetList } from './asset/list/AssetList';
import { Dashboard } from './dashboard/Dashboard';
import { Header, Sidebar } from './global';
import { Drawer } from './global/Drawer';
import { Event } from './global/event/Event';
import { ProjectList } from './project/list/ProjectList';
import { ReportRouter } from './report/ReportRouter';

const useAppClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    content: {
        display: 'flex',
        flex: 1,
    },
});

export const App = () => {
    const classes = useAppClasses();
    const element = useRoutes([
        { path: '/', element: <Dashboard /> },
        { path: '/assets', element: <AssetList /> },
        {
            path: '/projects',
            children: [
                { path: '/', element: <Navigate to='table' /> },
                { path: '/:view', element: <ProjectList /> }, // view: 'table' | 'calendar'
            ],
        },
        { path: '/plans', children: [{ path: '/create', element: <InspectionCreationWizard /> }] },
        { path: '/reports/*', element: <ReportRouter /> },
    ]);

    return (
        <div className={classes.root}>
            <Header />
            <div className={classes.content}>
                <Sidebar />
                {element}
            </div>
            <Drawers />
            <Event />
        </div>
    );
};

const useDrawersClasses = makeStyles({
    root: {
        width: 'min(100vw, 800px)',
    },
});

const Drawers = () => {
    const classes = useDrawersClasses();
    const [params, setParams] = useSearchParams();

    return (
        <>
            <Drawer
                open={!!params.get('asset')}
                onClose={() => (params.delete('asset'), setParams(params))}
                anchor='right'
                PaperProps={{ className: classes.root }}
            >
                <AssetDetails code={params.get('asset') ?? ''} />
            </Drawer>
        </>
    );
};
